/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LessonEditIn } from '../models/LessonEditIn';
import type { SimpleLessonOut } from '../models/SimpleLessonOut';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LessonsFm3Service {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Lesson Complete
     * ### Get the lesson
     *
     * Args:
     * - lesson_id `int`: The lesson_id of the lesson to get
     *
     * Permissions:
     * - `edit_force_pay`: The permission to edit the force_pay status of the lesson
     *
     * Returns:
     * - The lesson
     * @param lessonId
     * @returns SimpleLessonOut Successful Response
     * @throws ApiError
     */
    public getFm3GetLessonComplete(
        lessonId: number,
    ): CancelablePromise<SimpleLessonOut> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/fm3/lessons/lesson/{lesson_id}/complete',
            path: {
                'lesson_id': lessonId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Lesson Complete
     * ### Update the lesson with the force_pay status
     *
     * Args:
     * - lesson_id `int`: The lesson_id of the lesson to update
     * - lesson_edit `LessonEdit`: The lesson edit object with the force_pay status
     *
     * Permissions:
     * - `edit_force_pay`: The permission to edit the force_pay status of the lesson
     *
     * Returns:
     * - The lesson
     *
     * Raises:
     * - 400: If the lesson is not cancelled
     * - 422: If the start time is after the end time
     * @param lessonId
     * @param requestBody
     * @returns SimpleLessonOut Successful Response
     * @throws ApiError
     */
    public patchFm3UpdateLessonComplete(
        lessonId: number,
        requestBody: LessonEditIn,
    ): CancelablePromise<SimpleLessonOut> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/fm3/lessons/lesson/{lesson_id}/complete',
            path: {
                'lesson_id': lessonId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Lesson Complete
     * ### Get the lesson
     *
     * Args:
     * - lesson_id `int`: The lesson_id of the lesson to get
     *
     * Permissions:
     * - `edit_force_pay`: The permission to edit the force_pay status of the lesson
     *
     * Returns:
     * - The lesson
     * @param lessonId
     * @returns SimpleLessonOut Successful Response
     * @throws ApiError
     */
    public getFm3GetLessonCompleteVLatest(
        lessonId: number,
    ): CancelablePromise<SimpleLessonOut> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/fm3/lessons/lesson/{lesson_id}/complete',
            path: {
                'lesson_id': lessonId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Lesson Complete
     * ### Update the lesson with the force_pay status
     *
     * Args:
     * - lesson_id `int`: The lesson_id of the lesson to update
     * - lesson_edit `LessonEdit`: The lesson edit object with the force_pay status
     *
     * Permissions:
     * - `edit_force_pay`: The permission to edit the force_pay status of the lesson
     *
     * Returns:
     * - The lesson
     *
     * Raises:
     * - 400: If the lesson is not cancelled
     * - 422: If the start time is after the end time
     * @param lessonId
     * @param requestBody
     * @returns SimpleLessonOut Successful Response
     * @throws ApiError
     */
    public patchFm3UpdateLessonCompleteVLatest(
        lessonId: number,
        requestBody: LessonEditIn,
    ): CancelablePromise<SimpleLessonOut> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/latest/fm3/lessons/lesson/{lesson_id}/complete',
            path: {
                'lesson_id': lessonId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
